<template>
  <div class="toolbar-anchor">
    <div class="toolbar-widget">
      <slot name="toggle"/>
      <slot name="stats"/>
      <slot name="actions"/>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.toolbar-anchor {
  width: max-content;
}

.toolbar-widget {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  align-items: center;
  width: max-content;
  background: #FFFFFF;
  border-radius: 16px;
}
</style>


